module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6433bb08b9d15d5888e9492b2111024f.png";